import * as Types from '../../graphql.generated';

import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type DeleteTrackedPropertyPermissionsMutationVariables = Types.Exact<{
    uprn: Types.Scalars['String'];
}>;

export type DeleteTrackedPropertyPermissionsMutation = {
    __typename?: 'Mutation';
} & Pick<Types.Mutation, 'deleteTrackedPropertyPermissions'>;

export const DeleteTrackedPropertyPermissionsDocument = gql`
    mutation deleteTrackedPropertyPermissions($uprn: String!) {
        deleteTrackedPropertyPermissions(uprn: $uprn)
    }
`;
export type DeleteTrackedPropertyPermissionsMutationFn =
    Apollo.MutationFunction<
        DeleteTrackedPropertyPermissionsMutation,
        DeleteTrackedPropertyPermissionsMutationVariables
    >;

/**
 * __useDeleteTrackedPropertyPermissionsMutation__
 *
 * To run a mutation, you first call `useDeleteTrackedPropertyPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrackedPropertyPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrackedPropertyPermissionsMutation, { data, loading, error }] = useDeleteTrackedPropertyPermissionsMutation({
 *   variables: {
 *      uprn: // value for 'uprn'
 *   },
 * });
 */
export function useDeleteTrackedPropertyPermissionsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteTrackedPropertyPermissionsMutation,
        DeleteTrackedPropertyPermissionsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        DeleteTrackedPropertyPermissionsMutation,
        DeleteTrackedPropertyPermissionsMutationVariables
    >(DeleteTrackedPropertyPermissionsDocument, options);
}
export type DeleteTrackedPropertyPermissionsMutationHookResult = ReturnType<
    typeof useDeleteTrackedPropertyPermissionsMutation
>;
export type DeleteTrackedPropertyPermissionsMutationResult =
    Apollo.MutationResult<DeleteTrackedPropertyPermissionsMutation>;
export type DeleteTrackedPropertyPermissionsMutationOptions =
    Apollo.BaseMutationOptions<
        DeleteTrackedPropertyPermissionsMutation,
        DeleteTrackedPropertyPermissionsMutationVariables
    >;
